import { supabase } from '../lib/supabase';
import { Database } from '../types/database.types';
import { toast } from 'react-toastify';

type Operator = Database['public']['Tables']['operators']['Row'];

export { type Operator };

export async function fetchOperators(): Promise<Operator[]> {
  const { data, error } = await supabase
    .from('operators')
    .select('*')
    .order('createdAt', { ascending: false });

  if (error) {
    console.error('Error fetching operators:', error);
    throw new Error(error.message);
  }

  return data || [];
}

export async function updateOperatorField(
  id: string,
  field: string,
  value: string | number | boolean | string[] | null
): Promise<void> {
  const updatePromise = async () => {
    const { data, error } = await supabase
      .from('operators')
      .update({ id, [field]: value })
      .eq('id', id)
      .select('*');

    if (error) {
      console.error('Error updating operator:', { id, field, value, error });
      throw new Error(error.message);
    }

    if (!data) {
      throw new Error('No data returned from update operation');
    }

    return data;
  };

  // Convert field name to human-readable format
  const fieldDisplayName = field
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .toLowerCase();

  await toast.promise(updatePromise(), {
    pending: `Updating ${fieldDisplayName}...`,
    success: `Successfully updated ${fieldDisplayName}`,
    error: {
      render({ data }: { data: Error }) {
        return `Failed to update ${fieldDisplayName}: ${data.message || 'Unknown error'}`;
      },
    },
  });
}
